// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { useEffect, useRef, useState } from 'react';
import Matter from 'matter-js';
import decomp from 'poly-decomp';

import styles from './mochi-sparkles.module.scss';

try {
  window.decomp = decomp;
} catch {
  console.error('window not defined');
}

export const MochiSparkles = () => {
  const boxRef = useRef(null);
  const canvasRef = useRef(null);

  const [contraints, setContraints] = useState();
  const [scene, setScene] = useState();

  const handleResize = () => {
    setContraints(boxRef.current.getBoundingClientRect());
  };

  useEffect(() => {
    if (contraints) {
      const { width, height } = contraints;

      // dynamically update canvas and bounds
      scene.bounds.max.x = width;
      scene.bounds.max.y = height;
      scene.options.width = width;
      scene.options.height = height;
      scene.canvas.width = width;
      scene.canvas.height = height;
    }
  }, [scene, contraints]);

  useEffect(() => {
    const Engine = Matter.Engine;
    const Render = Matter.Render;
    const World = Matter.World;
    const Bodies = Matter.Bodies;
    const Body = Matter.Body;

    const engine = Engine.create({});
    const render = Render.create({
      element: boxRef.current,
      engine: engine,
      canvas: canvasRef.current,
      options: {
        background: 'transparent',
        wireframes: false,
      },
    });

    const leftSparkles = [];
    const rightSparkles = [];
    const topSparkles = [];

    // left & right sparkles
    for (let i = 0; i < 30; i++) {
      const leftRandomX = Math.random() * -300 - 50;
      const rightRandomX = Math.random() * 300 + 50 + window.innerWidth;
      const randomY = Math.random() * -400;
      const randomSizeA = Math.floor(Math.random()) + 6;
      const randomSizeB = Math.floor(Math.random()) + 12;
      const randomCount = Math.random() * 10;
      const color = ['#abd6fe', '#66fecb', '#fe9ee3', '#fef001'];
      const colorPos = Math.floor(Math.random() * 4);

      const options = {
        frictionAir: 0.035,
        render: {
          fillStyle: color[colorPos],
        },
      };

      if (randomCount > 5) {
        leftSparkles.push(
          Bodies.circle(leftRandomX, randomY, randomSizeA, options),
        );
        rightSparkles.push(
          Bodies.circle(rightRandomX, randomY, randomSizeA, options),
        );
      } else {
        leftSparkles.push(
          Bodies.rectangle(
            leftRandomX,
            randomY,
            randomSizeA,
            randomSizeB,
            options,
          ),
        );
        rightSparkles.push(
          Bodies.rectangle(
            rightRandomX,
            randomY,
            randomSizeA,
            randomSizeB,
            options,
          ),
        );
      }
    }

    // top sparkles
    for (let i = 0; i < 15; i++) {
      const randomX = Math.random() * window.innerWidth;
      const randomY = Math.random() * -400 - 150;
      const randomSizeA = Math.floor(Math.random()) + 4;
      const randomSizeB = Math.floor(Math.random()) + 8;
      const randomCount = Math.random() * 10;
      const color = ['#abd6fe', '#66fecb', '#fe9ee3', '#fef001'];
      const colorPos = Math.floor(Math.random() * 4);

      const options = {
        frictionAir: 0.05,
        isStatic: true,
        render: {
          fillStyle: color[colorPos],
        },
      };

      if (randomCount > 5) {
        topSparkles.push(Bodies.circle(randomX, randomY, randomSizeA, options));
      } else {
        topSparkles.push(
          Bodies.rectangle(randomX, randomY, randomSizeA, randomSizeB, options),
        );
      }
    }

    World.add(engine.world, [
      ...leftSparkles,
      ...rightSparkles,
      ...topSparkles,
    ]);

    Engine.run(engine);
    Render.run(render);

    topSparkles.map((sparkle) => {
      Body.setVelocity(sparkle, { x: 0, y: -10 });
      Body.setAngularVelocity(sparkle, Math.PI / 5);
      return '';
    });

    const runMatterBlow = () => {
      leftSparkles.map((sparkle) => {
        Body.setVelocity(sparkle, { x: 10, y: -(Math.random() * 10 + 9) });
        Body.setAngularVelocity(sparkle, Math.PI / 10);
        return '';
      });

      rightSparkles.map((sparkle) => {
        Body.setVelocity(sparkle, { x: -10, y: -(Math.random() * 10 + 9) });
        Body.setAngularVelocity(sparkle, Math.PI / 10);
        return '';
      });
    };

    const runMatterDrop = () => {
      topSparkles.map((sparkle) => {
        Body.setStatic(sparkle, false);
        return '';
      });
    };

    setTimeout(runMatterBlow, 700);
    setTimeout(runMatterDrop, 300);

    setContraints(boxRef.current.getBoundingClientRect());
    setScene(render);
    window.addEventListener('resize', handleResize);

    return () => {
      clearTimeout(runMatterBlow);
      clearTimeout(runMatterDrop);
    };
  }, []);

  return (
    <div ref={boxRef} className={styles.canvas}>
      <canvas ref={canvasRef} />
    </div>
  );
};
